<div class="np-form-control dx-fieldset texts">
  <div class="row g-3">
    <div class="col-12">
      <dx-validation-group id="LOGI" class="d-flex flex-column">
        <div *ngIf="!textsTemplateEditor" class="col-12 p-2">
          <div class="np-field">
            <np-inputControl
                [showPlaceLabel]="context?.model?.descriptionShort?.length > 0"
                [suppressTranslation]="false"
                field="DESCRIPTION_SHORT"
                labelText="{{ 'Produktbeschreibung' | translate }}"
            >
              <div class="contentSlot" slot="content">
                <dx-text-box
                    (onValueChanged)="update($event, 'DESCRIPTION_SHORT')"
                    [(value)]="context.model.descriptionShort"
                    [readOnly]="readOnlyForLinkedFields('DESCRIPTION_SHORT') || readOnly('productDescShort') || context.massDataChangeMode"
                    [showClearButton]="showClearButton('DESCRIPTION_SHORT')"
                >
                  <dx-validator
                      (onInitialized)="validationService.startAutomaticValidation($event)"
                      *ngIf="!context.templateView"
                      validationGroup="MAIN"
                  >
                    <dxi-validation-rule
                        [validationCallback]="validationService.validateField('DESCRIPTION_SHORT')"
                        type="async"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>

              <div *ngIf="hasTranslation" class="translationSlot" slot="translation">
                <dx-text-box
                    (onValueChanged)="translationUpdate(context.model.descriptionShort, $event.value)"
                    [(value)]="context.productTranslation.descriptionShort"
                    [readOnly]="readOnly('productDescShort')"
                    [showClearButton]="true"
                ></dx-text-box>
              </div>
            </np-inputControl>
          </div>
        </div>

        <div *ngIf="!textsTemplateEditor" class="col-12 p-2">
            <div class="row g-3 align-items-start">
                <div class="col">
                    <div class="np-field mb-0">
                        <np-inputControl (elementSelected)="elementSelectFunction($event)"
                                         (excelElementDropped)="excelElementDrop($event)"
                                         (onValueChanged)="update($event)"
                                         (showHTMLEditorChange)="showHTMLEditorChanged()"
                                         [(model)]="context.model"
                                         [(productTranslation)]="context.productTranslation"
                                         [(selectedElements)]="context.selectedElements"
                                         [(showHTMLEditor)]="showHTMLEditor"
                                         [dragFilter]="context.dragFilter"
                                         [isPrint]="context.isPrint"
                                         [showDragHandle]="context.showDragHandle"
                                         [showHTMLSwitch]="context.showHTMLSwitch"
                                         [showLinkButtons]="context.showLinkButtons"
                                         [suppressPlaceLabel]="true"
                                         [suppressTranslation]="false"
                                         field="DESCRIPTION_LONG"
                                         labelText="{{ 'Langbezeichnung' | translate }}">
                            <div class="contentSlot" slot="content">
                                <div *ngIf="showHTMLEditor && !context.isPrint" class="w-100">
                                    <dx-html-editor (onFocusOut)="update($event, 'DESCRIPTION_LONG')"
                                                    [(value)]="context.model.descriptionLong"
                                                    [readOnly]="readOnlyForLinkedFields('DESCRIPTION_LONG') || readOnly('productDescLong')"
                                                    allowSoftLineBreak="true"
                                                    class="w-100"
                                                    placeholder="DESCRIPTION_LONG">
                                        <dxo-toolbar>
                                            <dxi-item name="undo"></dxi-item>
                                            <dxi-item name="redo"></dxi-item>
                                            <dxi-item name="separator"></dxi-item>
                                            <dxi-item name="bold"></dxi-item>
                                            <dxi-item name="italic"></dxi-item>
                                            <dxi-item name="strike"></dxi-item>
                                            <dxi-item name="underline"></dxi-item>
                                            <dxi-item name="separator"></dxi-item>
                                            <dxi-item name="alignLeft"></dxi-item>
                                            <dxi-item name="alignCenter"></dxi-item>
                                            <dxi-item name="alignRight"></dxi-item>
                                            <dxi-item name="alignJustify"></dxi-item>
                                            <dxi-item name="separator"></dxi-item>
                                            <dxi-item [acceptedValues]="[1, 2, 3, 4, 5, false]" name="header"></dxi-item>
                                            <dxi-item name="separator"></dxi-item>
                                            <dxi-item name="orderedList"></dxi-item>
                                            <dxi-item name="bulletList"></dxi-item>
                                            <dxi-item name="separator"></dxi-item>
                                            <dxi-item name="link"></dxi-item>
                                        </dxo-toolbar>

                                        <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                      *ngIf="!context.templateView"
                                                      validationGroup="MAIN">
                                            <dxi-validation-rule [validationCallback]="validationService.validateField('DESCRIPTION_LONG')"
                                                                 type="async"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-html-editor>
                                </div>

                                <div *ngIf="!showHTMLEditor || context.isPrint">
                                    <label class="placeLabel {{ context.model?.descriptionLong?.length > 0 ? 'placeLabelSmall' : '' }}">
                                        DESCRIPTION_LONG
                                    </label>
                                    <dx-text-area (onValueChanged)="update($event, 'DESCRIPTION_LONG')"
                                                  [(value)]="context.model.descriptionLong"
                                                  [height]="130"
                                                  [readOnly]="readOnlyForLinkedFields('DESCRIPTION_LONG') || readOnly('productDescLong')">
                                        <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                      *ngIf="!context.templateView"
                                                      validationGroup="MAIN">
                                            <dxi-validation-rule [validationCallback]="validationService.validateField('DESCRIPTION_LONG')"
                                                                 type="async"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-area>
                                </div>
                            </div>

                            <div *ngIf="hasTranslation" class="translationSlot" slot="translation">
                                <div *ngIf="showHTMLEditor">
                                    <dx-html-editor (onValueChanged)="translationUpdate(context.model.descriptionLong, $event.value)"
                                                    [(value)]="context.productTranslation.descriptionLong"
                                                    [readOnly]="readOnly('productDescLong')"
                                                    placeholder="DESCRIPTION_LONG">
                                        <dxo-toolbar>
                                            <dxi-item name="undo"></dxi-item>
                                            <dxi-item name="redo"></dxi-item>
                                            <dxi-item name="separator"></dxi-item>
                                            <dxi-item name="bold"></dxi-item>
                                            <dxi-item name="italic"></dxi-item>
                                            <dxi-item name="strike"></dxi-item>
                                            <dxi-item name="underline"></dxi-item>
                                            <dxi-item name="separator"></dxi-item>
                                            <dxi-item name="alignLeft"></dxi-item>
                                            <dxi-item name="alignCenter"></dxi-item>
                                            <dxi-item name="alignRight"></dxi-item>
                                            <dxi-item name="alignJustify"></dxi-item>
                                            <dxi-item name="separator"></dxi-item>
                                            <dxi-item [acceptedValues]="[1, 2, 3, 4, 5, false]" name="header"></dxi-item>
                                            <dxi-item name="separator"></dxi-item>
                                            <dxi-item name="orderedList"></dxi-item>
                                            <dxi-item name="bulletList"></dxi-item>
                                            <dxi-item name="separator"></dxi-item>
                                            <dxi-item name="link"></dxi-item>
                                        </dxo-toolbar>

                                        <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                      *ngIf="!context.templateView"
                                                      validationGroup="MAIN">
                                            <dxi-validation-rule [validationCallback]="validationService.validateField('DESCRIPTION_LONG')"
                                                                 type="custom"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-html-editor>
                                </div>

                                <div *ngIf="!showHTMLEditor">
                                    <label class="placeLabel {{ context.productTranslation?.descriptionLong?.length > 0 ? 'placeLabelSmall' : '' }}">
                                        DESCRIPTION_LONG
                                    </label>
                                    <dx-text-area (onValueChanged)="translationUpdate(context.model.descriptionLong, $event.value)"
                                                  [(value)]="context.productTranslation.descriptionLong"
                                                  [height]="130"
                                                  [readOnly]="readOnly('productDescLong')">
                                        <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                      *ngIf="!context.templateView"
                                                      validationGroup="MAIN">
                                            <dxi-validation-rule [validationCallback]="validationService.validateField('DESCRIPTION_LONG')"
                                                                 type="async"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-area>
                                </div>
                            </div>
                        </np-inputControl>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 p-2">
          <div class="np-field">
            <np-inputControl [showPlaceLabel]="true"
                             (onValueChanged)="updateMarketingClaim($event)"
                             labelText="{{ 'Marketingclaim' | translate }}"
                             field="MARKETING_CLAIM">
              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="marketingClaim"
                             [readOnly]="readOnlyForLinkedFields('MARKETING_CLAIM')"
                             [showClearButton]="showClearButton('MARKETING_CLAIM')"
                             (onValueChanged)="updateMarketingClaim($event)">
                </dx-text-box>
              </div>
            </np-inputControl>
          </div>
        </div>

        <div class="col-12 p-2">
          <np-inputControl [suppressLabel]="true"
                           [suppressPlaceLabel]="true"
                           [suppressDragHandle]="true"
                           field="BENEFITS">
            <div slot="content" class="contentSlot">
              <dx-toolbar>
                <dxi-item
                    location="before"
                    cssClass="section-toolbar__title"
                    template="benefitsTitleTemplate">
                </dxi-item>
                <dxi-item location="before"
                          widget="dxButton"
                          [options]="{ stylingMode: 'text', type: 'default', icon: 'add', onClick: createNewBenefitFeature }">
                </dxi-item>
                <div *dxTemplate="let data of 'benefitsTitleTemplate'">
                  {{ 'Vorteile' | translate }}
                </div>
              </dx-toolbar>
              <div class="feature-list">
                <dx-sortable
                    [data]="benefitFeatures"
                    itemOrientation="vertical"
                    handle=".feature-row__drag"
                    dragDirection="vertical"
                    (onReorder)="onFeaturesReorder($event, 'udf_NMBENEFITS-1.0')"
                >
                  <div
                      *ngFor="let benefit of benefitFeatures; let i = index"
                      dxSortableItem
                  >
                    <np-inputControl [suppressLabel]="true"
                                     [suppressPlaceLabel]="true"
                                     [suppressLinkButton]="true"
                                     field="BENEFIT_{{i + 1}}">
                      <div slot="content" class="contentSlot">
                        <div
                            class="feature-row"
                            (click)="onBenefitFeatureRowClick(benefit)"
                            [class.catalog-row--selected]="selectedBenefitFeature === benefit"
                        >
                          <div class="feature-row__drag">
                            <i class="dx-icon-menu"></i>
                          </div>
                          <div class="feature-row__main">
                            <div class="catalog-row__title">
                              <dx-text-box [(value)]="benefit.value"
                                           [readOnly]="readOnlyForLinkedFields('FVALUE')"
                                           [showClearButton]="showClearButton('FVALUE')"
                                           (onValueChanged)="updateBenefitFeatureValue($event, benefit)">
                              </dx-text-box>
                            </div>
                          </div>
                          <div class="feature-row__actions">
                            <dx-button
                                icon="trash"
                                stylingMode="text"
                                type="default"
                                (onClick)="onFeatureDeleteClick(benefit, $event, 'udf_NMBENEFITS-1.0')"
                            >
                            </dx-button>
                          </div>
                        </div>
                      </div>
                    </np-inputControl>
                  </div>
                </dx-sortable>
              </div>
            </div>
          </np-inputControl>
        </div>

        <div class="col-12 p-2">
          <np-inputControl [suppressLabel]="true"
                           [suppressPlaceLabel]="true"
                           [suppressDragHandle]="true"
                           field="TOP_FEATURES">
            <div slot="content" class="contentSlot">
              <dx-toolbar>
                <dxi-item
                    location="before"
                    cssClass="section-toolbar__title"
                    template="topFeaturesTitleTemplate">
                </dxi-item>

                <dxi-item location="before"
                          widget="dxButton"
                          [options]="{ stylingMode: 'text', type: 'default', icon: 'add', onClick: createNewTopFeature }">
                </dxi-item>

                <div *dxTemplate="let data of 'topFeaturesTitleTemplate'">
                  {{ 'Unique Selling Point (USP´s)' | translate }}
                </div>
              </dx-toolbar>
              <div class="feature-list">
                <dx-sortable
                    [data]="topFeatures"
                    itemOrientation="vertical"
                    handle=".feature-row__drag"
                    dragDirection="vertical"
                    (onReorder)="onFeaturesReorder($event, 'udf_NMTOPFEATURES-1.0')"
                >
                  <div
                      *ngFor="let topFeature of topFeatures; let i = index"
                      dxSortableItem
                  >
                    <np-inputControl [suppressLabel]="true"
                                     [suppressPlaceLabel]="true"
                                     [suppressLinkButton]="true"
                                     field="TOP_FEATURE_{{i + 1}}">
                      <div slot="content" class="contentSlot">
                        <div
                            class="feature-row"
                            (click)="onTopFeatureRowClick(topFeature)"
                            [class.catalog-row--selected]="selectedTopFeature === topFeature"
                        >
                          <div class="feature-row__drag">
                            <i class="dx-icon-menu"></i>
                          </div>
                          <div class="feature-row__main">
                            <div class="catalog-row__title">
                              <dx-text-box [(value)]="topFeature.value"
                                           [readOnly]="readOnlyForLinkedFields('FVALUE')"
                                           [showClearButton]="showClearButton('FVALUE')"
                                           (onValueChanged)="updateTopFeatureValue($event, topFeature)">
                              </dx-text-box>
                            </div>
                          </div>
                          <div class="feature-row__actions">
                            <dx-button
                                icon="trash"
                                stylingMode="text"
                                type="default"
                                (onClick)="onFeatureDeleteClick(topFeature, $event, 'udf_NMTOPFEATURES-1.0')"
                            >
                            </dx-button>
                          </div>
                        </div>
                      </div>
                    </np-inputControl>
                  </div>
                </dx-sortable>
              </div>
            </div>
          </np-inputControl>
        </div>


        <div *ngIf="wawiFieldsForTextsAvailable && !textsTemplateEditor" class="np-section w-100">
          <div class="np-texts-wawi-header">{{ ('Ihre' | translate) + ' ' + loginService.wawiSettings.name + ' ' + ('Zusatzinformationen' | translate) }}</div>
          <wawi
              [(model)]="context.model"
              [showLinkButtons]="true"
              [selectedTabToShow]="'Texte'"
              (onValueChanged)="update($event)"
              (elementSelected)="elementSelectFunction($event)"
              [showDragHandle]="context.showDragHandle"
              [dragFilter]="'> *'"
              (excelElementDropped)="excelElementDrop($event)"
          ></wawi>
        </div>

        <div *ngIf="loginService.hasAddonSEO && !textsTemplateEditor" class="col-12 p-2">
          <div class="np-field">
            <np-inputControl [showPlaceLabel]="context.model?.metaTitel?.length > 0"
                             labelText="{{ 'Meta Titel' | translate }}"
                             field="META_TITLE">
              <div slot="content" class="contentSlot">
                <dx-text-box [(value)]="context.model.metaTitel"
                             [readOnly]="readOnlyForLinkedFields('META_TITLE') || readOnly('seoTitle')"
                             [showClearButton]="showClearButton('META_TITLE')"
                             valueChangeEvent="keyup"
                             (onValueChanged)="update($event, 'META_TITLE')">
                  <dx-validator *ngIf="!context.templateView"
                                validationGroup="SEO"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField('META_TITLE')"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
                <seo_component *ngIf="context.model?.metaTitel?.length >0" [metaTitel]="context.model.metaTitel"></seo_component>
              </div>
            </np-inputControl>
          </div>

          <!--MetaDescription-->
          <div class="np-field">
            <np-inputControl [showPlaceLabel]="context.model?.metaDescription?.length > 0"
                             labelText="{{ 'Meta Beschreibung' | translate }}"
                             field="META_DESCRIPTION">

              <div slot="content" class="contentSlot">
                <dx-text-area [(value)]="context.model.metaDescription"
                              valueChangeEvent="keyup"
                              [readOnly]="readOnlyForLinkedFields('META_DESCRIPTION') || readOnly('seoDescription')"
                              [height]="130"
                              (onValueChanged)="update($event, 'META_DESCRIPTION')">
                  <dx-validator *ngIf="!context.templateView"
                                validationGroup="SEO"
                                (onInitialized)="validationService.startAutomaticValidation($event)">
                    <dxi-validation-rule type="async"
                                         [validationCallback]="validationService.validateField('META_DESCRIPTION')"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-area>
                <seo_component *ngIf="context.model?.metaDescription?.length > 0"
                               [metaDescription]="context.model.metaDescription"></seo_component>
              </div>
            </np-inputControl>
          </div>
          <div>
            <snippet *ngIf="context.model?.metaTitel?.length >0 || context.model?.metaDescription?.length > 0"
                     [metaTitel]="context.model.metaTitel" [metaDescription]="context.model.metaDescription"></snippet>
          </div>
        </div>
      </dx-validation-group>
    </div>
  </div>

  <div class="color4Text">
    <div *ngIf="showTextsValidationSummary">
      <table>
        <tr *ngFor="let msg of textsValidationMessages">
          <td>{{ translateMessage(msg) }}</td>
        </tr>
      </table>
    </div>
  </div>
</div>